import ApiConfig from '../../config/ApiConfig';
import Network from './network';

export const getSyncFilesList = async (page: number, limit: number) => {
  const response = await Network.get({
    url: ApiConfig.api.selfService.getSyncFilesList,
    params: {
      page,
      limit,
    },
  });
  return response.data;
};

export const getPresignedUrlToUpload = async (file: File) => {
  const response = await Network.post({
    url: ApiConfig.api.selfService.uploadRosterFile,
    body: {
      fileName: file.name,
      contentType: file.type,
    },
  });
  return response?.data;
};

export const uploadFileToPresignedURL = async (
  presignedUrl: string,
  file: File,
) => {
  try {
    const response = await fetch(presignedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type,
      },
      body: file,
    });

    if (!response.ok) {
      throw new Error('Failed to upload file to presigned URL');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};
